import { render } from "./HelpCoursesDialog.vue?vue&type=template&id=9bf2e0a8"
import script from "./HelpCoursesDialog.vue?vue&type=script&lang=js"
export * from "./HelpCoursesDialog.vue?vue&type=script&lang=js"

import exportComponent from "/Users/andreaskura/repos/cio-online-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__